import React, {ReactElement} from 'react';
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import {Typography} from '@customink/pigment-react';
import ProductGrid from '../ProductGrid';
import ShirtImage from '../../assets/Shirt.svg';
import '../ProductsListingCard/index.scss';
import './index.scss';

type PlaceholderProductsListingProps = {
  numCol: number;
};

const EmptyPlaceholder = (
  <Card className="productCard productCard-placeholder empty" />
);

const PlaceholderWithImage = (
  <Card className="productCard productCard-placeholder">
    <CardContent className="productCard-content-image">
      <div className="placeholderWrapper">
        <CardMedia
          className="productCard-image"
          component="img"
          image={ShirtImage}
          alt="Example Product"
        />
      </div>
    </CardContent>
    <div className="stores-productCard-details">
      <CardContent className="productInfo">
        <h4 className="productCard-name">Your Product Here</h4>
        <div className="stores-productCard-price">
          <Typography className="sub">$0.00</Typography>
        </div>
      </CardContent>
    </div>
  </Card>
);

const PlaceholderProductsListing: React.FC<PlaceholderProductsListingProps> = ({
  numCol
}: PlaceholderProductsListingProps): ReactElement => {
  return (
    <div className="storeProductListing">
      <Container className="storeProductListing-container">
        <div className="categories" />
        <div className="storeProductList">
          <ProductGrid.Container>
            <ProductGrid.Item
              numColLg={numCol}
              numColMd={numCol}
              gridKey="0"
              numColSm={2}>
              {PlaceholderWithImage}
            </ProductGrid.Item>
            <ProductGrid.Item
              numColLg={numCol}
              numColMd={numCol}
              gridKey="1"
              numColSm={2}>
              {EmptyPlaceholder}
            </ProductGrid.Item>
            <ProductGrid.Item
              numColLg={numCol}
              numColMd={numCol}
              gridKey="2"
              numColSm={2}>
              {EmptyPlaceholder}
            </ProductGrid.Item>
          </ProductGrid.Container>
        </div>
      </Container>
    </div>
  );
};

export default PlaceholderProductsListing;
